import React from "react";
import { motion } from "framer-motion";

interface LoaderProps {
  size?: "sm" | "md" | "lg";
}

const Loader: React.FC<LoaderProps> = ({ size = "md" }) => {
  const containerVariants = {
    animate: {
      rotate: 360,
      transition: {
        duration: 3,
        repeat: Infinity,
        ease: "linear",
      },
    },
  };

  const circleVariants = {
    animate: (i: number) => ({
      scale: [1, 1.2, 1],
      transition: {
        duration: 1.5,
        repeat: Infinity,
        delay: i * 0.2,
        ease: "easeInOut",
      },
    }),
  };

  // Size variants
  const sizeClasses = {
    sm: "size-4",
    md: "size-6",
    lg: "size-8",
  };

  const circleSize = {
    sm: "size-1",
    md: "size-2",
    lg: "size-2.5",
  };

  return (
    <motion.div className={`relative grid place-content-center ${sizeClasses[size]}`} variants={containerVariants} animate="animate">
      {[...Array(4)].map((_, i) => (
        <motion.div
          key={i}
          className={`absolute rounded-full ${circleSize[size]} bg-gorgonzola-blue-300`}
          style={{
            top: i === 0 || i === 1 ? 0 : "auto",
            bottom: i === 2 || i === 3 ? 0 : "auto",
            left: i === 0 || i === 3 ? 0 : "auto",
            right: i === 1 || i === 2 ? 0 : "auto",
          }}
          variants={circleVariants}
          animate="animate"
          custom={i}
        />
      ))}
    </motion.div>
  );
};

export default Loader;
